import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Socket from '../../connection/socket';
import { GreenroomState } from '../../stores/types/types';
import RightClickMenu, { MenuItem } from '../general-components/right-click-menu';
import * as SessionActions from '../../stores/actions/session';

interface Props {
	clickCoordinates?: [number, number];
	contextMenuId: string;
	socket: Socket | null;
	userId: number;
}

export default function VideoFeedContextMenu(props: Props) {
	const dispatch = useDispatch();

	const {
		clickCoordinates,
		contextMenuId,
		userId,
	} = props;
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting);
	const onsiteUsers = useSelector((state: GreenroomState) => state.SessionReducer.onsiteUsers);

	const isOnsiteUser = useMemo(() => {
		if (userId && onsiteUsers?.includes(userId)) {
			return true;
		}
		return false;
	}, [onsiteUsers, userId]);

	const handleToggleOnsite = () => {
		if (!token || !meeting) return;
		const settings = { onsite_user: !isOnsiteUser };
		dispatch(SessionActions.updateUserMeetingSettings(token, meeting.meeting, userId, settings));
	};

	const menuItems: MenuItem[] = useMemo(() => [
		{
			checkboxValue: isOnsiteUser,
			handleClick: handleToggleOnsite,
			text: 'Onsite',
		},
	], [isOnsiteUser, userId]);

	return <RightClickMenu
		contextMenuId={contextMenuId}
		items={menuItems}
		clickCoordinates={clickCoordinates}
	/>;
}
